<template>
  <a class="building-image-link" :href="imageSrc" :data-lightbox="groupName">
    <img class="building-image-preview" :src="imageTumbnail" :height="height" />
  </a>
</template>

<script>
export default {
  name: 'BuildingImage',
  props: {
    imageSrc: { type: String },
    imageTumbnail: { type: String },
    height: { type: Number },
    groupName: { type: String, default: 'Красная Книга Москвы' },
  },
};
</script>

<style scoped>
.building-image-link,
.building-image-link:hover,
.building-image-link:active,
.building-image-link:visited,
.building-image-link:focus {
  display: inline-block;
  text-decoration: none;
  outline: none;
  box-shadow: none;
}

.building-image-preview {
  display: block;
  border: 0;
  outline: none;
  box-shadow: none;
}
</style>
